import { useSheetStore } from '@/shared/stores/sheet-store';

// The therapist may have left mid-save, so a late resolve must not pop another sheet — including
// a reopened edit form for the same record. Only pop if the sheet the save started from is still
// the top one: `openSheet` gives every opening its own object, and `replaceSheets` hands back
// untouched sheets as they are, so that object is the opening's identity.
export function useSaveThenGoBack(onError?: (error: unknown) => void) {
    const goBack = useSheetStore((state) => state.goBack);

    return async (save: () => Promise<unknown>) => {
        const sheetAtSubmit = useSheetStore.getState().currentSheet;

        try {
            await save();

            if (sheetAtSubmit && useSheetStore.getState().currentSheet === sheetAtSubmit) {
                goBack();
            }
        } catch (error) {
            // The form stays mounted with whatever the therapist entered, because nothing here
            // resets or navigates. Failures the form cannot show itself surface as the mutation's toast.
            onError?.(error);
        }
    };
}
